<template>
  <div class="page">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'BasePage'
}
</script>

<style lang="scss" scoped>
  @import './base-page'
</style>



// WEBPACK FOOTER //
// src/components/BasePage/BasePage.vue